/**
 * Brand colour, applied at runtime.
 *
 * The interface is styled from CSS variables rather than fixed colours, so
 * changing the organisation's primary colour under Admin > Settings recolours
 * every screen. The defaults live in index.css; this overrides them for the
 * signed-in user once their organisation's setting is known.
 */

/** "#1B4332" -> "27 67 50", the channel form Tailwind needs for opacity. */
export const hexToRgbChannels = (hex) => {
  if (typeof hex !== 'string') return null;
  let h = hex.trim().replace(/^#/, '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (!/^[0-9a-f]{6}$/i.test(h)) return null;
  const n = parseInt(h, 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
};

/** A darker version, for hover states. */
const darken = (channels, amount = 0.35) =>
  channels
    .split(' ')
    .map((v) => Math.max(0, Math.round(Number(v) * (1 - amount))))
    .join(' ');

/**
 * Paint the interface in `hex`. Ignores anything that is not a valid colour,
 * so a bad value saved in settings leaves the default in place rather than
 * producing an unreadable page.
 */
export const applyBrandColor = (hex) => {
  const channels = hexToRgbChannels(hex);
  if (!channels) return false;
  const root = document.documentElement;
  root.style.setProperty('--brand-rgb', channels);
  root.style.setProperty('--brand-dark-rgb', darken(channels));
  return true;
};
